// msalConfig.js
// MSAL configuration for Entra External Identities CIAM
// Supports: Email+Password, Email OTP, Groups-based authorization

import { LogLevel } from '@azure/msal-browser';

const CLIENT_ID = 'ca9054d0-f97b-4a0c-89ac-03169cd89f90';
const CIAM_DOMAIN = 'globaliqhub.ciamlogin.com';

export const msalConfig = {
  auth: {
    clientId: CLIENT_ID,
    authority: `https://${CIAM_DOMAIN}/`,
    knownAuthorities: [CIAM_DOMAIN],
    redirectUri: '/',
    postLogoutRedirectUri: '/',
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error: console.error(message); break;
          case LogLevel.Warning: console.warn(message); break;
          default: break;
        }
      },
      piiLoggingEnabled: false,
      logLevel: LogLevel.Warning,
    },
  },
};

// Login scopes — minimal for all users
export const loginRequest = {
  scopes: ['openid', 'profile', 'email', 'offline_access'],
};

// Graph API scopes for reading own profile + group membership
export const profileRequest = {
  scopes: ['User.Read'],
};

// Graph API scopes for admin user management
export const adminRequest = {
  scopes: ['User.ReadWrite.All', 'GroupMember.ReadWrite.All', 'Mail.Send'],
};

// Group configuration — update after creating groups in Entra
export const groupConfig = {
  goaAdminGroupId: process.env.REACT_APP_GOA_ADMIN_GROUP_ID || 'db7f5fcc-4156-420a-966a-72f0fc07f442',
  goaMembersGroupId: process.env.REACT_APP_GOA_MEMBERS_GROUP_ID || '6e508401-d9fd-483c-ba87-f2d5713f4826',
  goaAdminGroupName: 'GoaAdmin',
  goaMembersGroupName: 'GoaMembers',
};

export const graphConfig = {
  graphEndpoint: 'https://graph.microsoft.com/v1.0',
};
